import { ReactChild, Suspense } from 'react'
import Spinning from './Spinner/Spinning'

type LazyPageLoadingProps = {
  children: ReactChild
}

export const LazyPageLoading = ({ children }: LazyPageLoadingProps) => (
  <Suspense fallback={<Spinning />}>{children}</Suspense>
)
